import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { formatarReal } from "../../../utils/formatar";
import logo from '../../../assets/images/logo_salvador.png';

export default class ModalPix extends Component {
    state = {
        textButton: "Copiar"
    }

    Image = (data) => {
        return <img src={`data:image/jpeg;base64,${data}`}/>
    }

    meusLancamentos = (e) => {

    }

    render() {
        return(
            <ModalContainer zIndex={100} className={ this.props.classContainer ? this.props.classContainer : '' }>
                <ModalDialog className="nosso-modal tamanho-modal-500 modal-margin p-0">                    
                    <div className="row w-100 bg-primary m-0 d-flex align-items-center">
                        <div className="col-9">
                            <h1 className="text-light">Por favor, efetue o pagamento no valor de { formatarReal(this.props.valorTotal) }</h1>
                        </div>
                        <div className="col-3">
                            <img src={logo} style={{width: '5rem'}} />
                        </div>
                    </div>
                    <div className="row w-100 m-0 mt-2">
                        <div className="col-11 d-flex flex-column ml-4">
                            <p className="font-weight-bold mb-2">Escaneie este código para pagar</p>
                            <p className="mb-2"><span className="font-weight-bold">1.</span> Acesse seu Internet Banking ou app de pagamentos.</p>
                            <p className="mb-2"><span className="font-weight-bold">2.</span> Escolha pagar via PIX.</p>
                            <p className="mb-2"><span className="font-weight-bold">3.</span> Escaneie o seguinte código.</p>
                        </div>
                    </div>
                    <div className="row w-100 m-0">
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            { this.Image(this.props.dataPix.imagem_base64) }
                        </div>
                    </div>
                    <div className="row w-100 m-0">
                        <div className="col-11 d-flex flex-column ml-4">
                            <p className="font-weight-bold mb-2"><FontAwesomeIcon icon={faClock} /> Pague e será creditado na hora</p>
                            <p className="mb-2">Ou copie este código QR para fazer o pagamento</p>
                            <p className="mb-2">Escolha pagar via PIX pelo seu Internet Banking ou app de pagamento. Depois, cole o seguinte código:</p>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" value={this.props.dataPix.emv} placeholder="Código PIX" aria-label="Recipient's username" aria-describedby="basic-addon2"/>
                                <div className="input-group-append">
                                    <button className="btn btn-outline-secondary" onClick={()=>{
                                        navigator.clipboard.writeText(this.props.dataPix.emv);
                                        this.setState({textButton: "Copiado !"});
                                    }}>{ this.state.textButton }</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row w-100 m-0 mb-3">
                        <div className="col-11 d-flex ml-4 align-items-center justify-content-between">
                            <button type="button" className="btn btn-primary" onClick={()=>{
                                this.props.controller.modalPagamentoPix = false;
                            }}>Fechar</button>
                            <button type="button" className="btn btn-link m-0" onClick={() => { 
                                if(this.props.consultaController !== undefined) { 
                                    this.props.consultaController.fecharTelaImportExport();
                                    this.props.consultaController.setSituacao("A");
                                    this.props.consultaController.setBl(this.props.controller.numBl)
                                    this.props.consultaController.listar(); 
                                } else {
                                    this.props.controller.modalPagamentoPix = false;
                                    this.props.controller.listar();
                                }
                            }}><p className="font-weight-bold m-0">Ver em meus lançamentos</p></button>
                        </div>
                    </div>
                </ModalDialog>
            </ModalContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/ModalPix.js